import React, { createContext, useContext, useState } from "react";

const GlobalStatesContext = createContext();

export const GlobalStates = ({ children }) => {
	const [isDarkMode, setIsDarkMode] = useState(false);
	const [isTextArea, setIsTextArea] = useState("");

	const theme = isDarkMode ? "light" : "dark";

	return (
		<GlobalStatesContext.Provider
			value={{
				theme,
				isDarkMode,
				isTextArea,
				setIsDarkMode,
				setIsTextArea,
			}}
		>
			{children}
		</GlobalStatesContext.Provider>
	);
};

export const useGlobalStates = () => {
	const context = useContext(GlobalStatesContext);
	if (!context) {
		throw new Error("useGlobalStates must be used within a GlobalState!");
	}

	return context;
};
